import PropTypes from 'prop-types';
import { CalendarDays } from 'lucide-react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { Box, List, ListItemText } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;
  const location = useLocation();
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        color: 'white',
        '&.active': {
          color: 'black',
          bgcolor: 'white',
          // bgcolor: 'pink',
          // color: 'White',
          // border: '1px  solid',
          fontWeight: 'fontWeightBold',
        },
        marginBottom: '10px',
      }}
    >
      <StyledNavItemIcon>
        {(title === 'Dashboard' || title === 'Dashboard') &&
          (location.pathname === '/dashboard/message' ? ( // Assuming you want to display a different image for the message
            <img
              src={`/assets/icons/navbar/Dashboard-black.webp`}
              alt="message"
              style={{ width: 'auto', height: '100%' }}
            />
          ) : (
            <img src={`/assets/icons/navbar/Dashboard.webp`} alt="message" style={{ width: 'auto', height: '100%' }} />
          ))}

        {title === 'Whatsapp' &&
          (location.pathname === '/dashboard/blog' ? (
            <img
              src={`/assets/icons/navbar/whatsapp-icon.webp`}
              alt="lucky meter"
              style={{ width: 'auto', height: '100%' }}
            />
          ) : (
            <img
              src={`/assets/icons/navbar/whatsapp-icon.webp`}
              alt="lucky meter"
              style={{ width: 'auto', height: '100%' }}
            />
          ))}

        {title === 'Event' && (
          <CalendarDays size={16}/>
        )}
      </StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
